import { Menu, MenuItem } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FilterIcon from "../../Assets/svgs/FilterIcon";
import ImportButtonIcon from "../../Assets/svgs/ImportButtonIcon";
import { ImportIcon } from "../../Assets/svgs/ImportIcon";
import {
  INITIAL_CONTACT_FILTER_STATE,
  LIMIT_PER_PAGE,
} from "../../Common/Constants";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import { Pagination } from "../../Common/Pagination";
import { Table } from "../../Common/Table";
import useDebounce from "../../Common/useDebounce";
import { downloadFileAsBlob, maskPhoneNumber } from "../../Common/utils";
import { CallInstantModal } from "../../Model/CallInstantModal";
import { ConfirmModel } from "../../Model/ConfirmModel";
import ContactGroupFilterModal from "../../Model/ContactGroupFilterModal";
import { ErrorModel } from "../../Model/ErrorModel";
import InstantEmailModal from "../../Model/InstantEmailModal";
import LowCreditModal from "../../Model/LowCreditModal";
import { SuccessModel } from "../../Model/SuccessModel";
import UploadContactUsersForGroupModal from "../../Model/UploadContactUsersForGroupModal";
import {
  resetPagination,
  setPage,
  setTotalItems,
  setTotalPages,
} from "../../Redux/Slice/Common/PaginationSlice";
import { deleteContactGroup } from "../../Redux/Slice/Contacts/Contact Group/DeleteContactGroupSlice";
import { downloadContactGroupTemplate } from "../../Redux/Slice/Contacts/Contact Group/DownloadGroupUploadTemplateSlice";
import { getContactGroupList } from "../../Redux/Slice/Contacts/Contact Group/GetContactGroupListSlice";
import { updateContactGroup } from "../../Redux/Slice/Contacts/Contact Group/UpdateContactGroupSlice";
import { DeleteContact } from "../../Redux/Slice/Contacts/DeleteContactSlice";
import { getContactList } from "../../Redux/Slice/Contacts/GetContactsListSlice";
import { ScheduleCallPopup } from "./ScheduleCallPopup";
import { ScheduleEmailPopup } from "./ScheduleEmailPopup";

export const ContactList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [schedulePopup, showSchedulePopup] = useState(false);
  const [scheduleEmailPopup, showScheduleEmailPopup] = useState(false);
  const [localItemsPerPage, setLocalItemsPerPage] = useState(LIMIT_PER_PAGE);
  const [showInstantCallPopup, setShowInstantCallPopup] = useState({
    visible: false,
    data: null,
  });
  const [showInstantEmailPopup, setShowInstantEmailPopup] = useState({
    visible: false,
    data: null,
  });
  const Contacts = useSelector((state) => state.contacts.ContactsList);
  const contactGroupListData = useSelector(
    (state) => state?.contactGroups?.contactGroupList
  );
  const [selectedTab, setSelectedTab] = useState(
    location.hash == "#groups" ? 2 : 1
  );
  const [filterData, setFilterData] = useState({
    isVisible: false,
    data: INITIAL_CONTACT_FILTER_STATE,
  });
  const { userPlanFeatures } = useSelector((s) => s?.userPlanDetails);
  const [showLowCreditModal, setShowLowCreditModal] = useState(false);
  const [contactList, setContactsList] = useState([]);
  const [contactGroupList, setContactGroupList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showUploadGroupUsers, setShowUploadGroupUsers] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isAllchecked = () => {
    const currentList = selectedTab == 1 ? contactList : contactGroupList;
    const found = currentList.some((x) => !x.checkedRow);
    if (found || !currentList?.length) {
      return false;
    } else {
      return true;
    }
  };

  const allChecked = isAllchecked();

  const closePopup = (value = "default", error = null) => {
    showSchedulePopup(false);
    if (value === "success") {
      setSuccessMessage("Call Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        setContactsList(Contacts.data);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" && error?.message
          ? error?.message
          : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeScheduleEmailPopup = (value = "default", error = null) => {
    showScheduleEmailPopup(false);
    if (value === "success") {
      setSuccessMessage("Email Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        setContactsList(Contacts.data);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" && error?.message
          ? error?.message
          : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeInstantCallPopup = (value = "default", error = null) => {
    setShowInstantCallPopup({
      visible: false,
      data: null,
    });
    if (value === "success") {
      setSuccessMessage("Call Scheduled Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" ? error?.message : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const closeInstantEmailPopup = (value = "default", error = null) => {
    setShowInstantEmailPopup({
      visible: false,
      data: null,
    });
    if (value === "success") {
      setSuccessMessage("Email Sent successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else if (value === "error") {
      setIsLoading(false);
      const apiErrorMessage =
        error && typeof error?.message == "string" ? error?.message : null;
      const apiErrorCode = error && error?.code ? error?.code : null;
      if (apiErrorCode == 1030) {
        setShowLowCreditModal(true);
      } else {
        setErrorMessage(apiErrorMessage ?? "Something went wrong.");
        setErrorModel(true);
        setTimeout(() => {
          setErrorModel(false);
        }, 1500);
      }
    }
  };

  const updateContactGroupData = async (payload) => {
    setIsLoading(true);

    const result = await dispatch(updateContactGroup(payload));
    if (
      updateContactGroup.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Group Updated Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getContactsList();
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const getIndivitualContactsList = async (page = 1, limit) => {
    setIsLoading(true);
    const result = await dispatch(getContactList({ searchText, page, limit }));
    setIsLoading(false);
    dispatch(setPage(result?.payload?.pagination?.currentPage));
    dispatch(setTotalItems(result?.payload?.pagination?.totalItems));
    dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
  };

  const getGroupList = async (page = 1, limit, filter = filterData.data) => {
    setIsLoading(true);
    const result = await dispatch(
      getContactGroupList({
        searchText,
        page,
        isActive: filter.isActive,
        limit,
      })
    );
    setIsLoading(false);
    dispatch(setPage(result?.payload?.pagination?.currentPage));
    dispatch(setTotalItems(result?.payload?.pagination?.totalItems));
    dispatch(setTotalPages(result?.payload?.pagination?.totalPages));
  };

  const getContactsList = async (page = 1, limit, filterData) => {
    if (selectedTab == 1) {
      getIndivitualContactsList(page, limit);
    } else {
      getGroupList(page, limit, filterData);
    }
  };

  const setPageList = (contacts) => {
    if (!!contacts) {
      return contacts.map((item, index) => {
        return {
          firstName: item?.firstName,
          lastName: item?.lastName,
          email: item?.email,
          avatar: item?.avatar,
          phoneNumber: item?.phoneNumber
            ? maskPhoneNumber(item?.phoneNumber, item.countryCallingCode)
            : "",
          checkedRow: item?.checkedRow ? item?.checkedRow : false,
          creationDate: dateFormat(item?.createdAt),
          id: item?.id,
        };
      });
    }
  };
  // useEffect(() => {
  //   getContactsList(1);
  // }, []);
  useEffect(() => {
    if (Contacts) {
      setContactsList(Contacts.data);
    }
  }, [Contacts]);

  useEffect(() => {
    if (
      contactGroupListData &&
      contactGroupListData?.data &&
      Array.isArray(contactGroupListData?.data)
    ) {
      setContactGroupList(
        contactGroupListData?.data.map((item, index) => {
          return {
            ...item,
            creationDate: dateFormat(item?.createdAt),
            members: Array.isArray(item?.contacts) ? item?.contacts?.length : 0,
          };
        })
      );
    }
  }, [contactGroupListData]);

  const debouncedGetContactList = useCallback(debounce(getContactsList, 500), [
    searchQuery,
  ]);

  useEffect(() => {
    debouncedGetContactList();
  }, [searchQuery, debouncedGetContactList]);

  useEffect(() => {
    setSearchText("");
    setFilterData({
      isVisible: false,
      data: INITIAL_CONTACT_FILTER_STATE,
    });
    setContactsList([]);
    dispatch(resetPagination());
    getContactsList();
  }, [selectedTab]);

  const columns =
    selectedTab == 1
      ? [
          {
            label: "First Name",
            key: "firstName",
            avatarKey: "avatar",
            className: "profile__link",
          },
          {
            label: "Last Name",
            key: "lastName",
            className: "cellText",
          },
          {
            label: "Email",
            key: "email",
            className: "cellText",
          },
          {
            label: "Phone Number",
            key: "phoneNumber",
            className: "cellText",
          },
          {
            label: "Date Created",
            key: "creationDate",
            className: "cellText",
          },
        ]
      : [
          {
            label: "Name",
            key: "name",
            avatarKey: "avatar",
            className: "profile__link",
          },
          {
            label: "Creation Date",
            key: "creationDate",
            className: "cellText",
          },
          {
            label: "Members",
            key: "members",
            className: "cellText",
          },
          {
            label: "Status",
            key: "isActive",
            className: "switchBtn",
            onSwitchValueChanged: (val, rowData) => {
              updateContactGroupData({
                id: rowData?.id,
                payload: {
                  isActive: val,
                },
              });
            },
          },
        ];

  const actionMenus = [];

  if (userPlanFeatures?.OUT_BOUND_CALL) {
    actionMenus.push(
      {
        title: "Instant Call",
        type: "INSTANT_CALL",
        onClick: (rowData) => {
          onCallInstant(rowData);
        },
      },
      {
        title: "Schedule Call",
        type: "SCHEDULE_CALL",
        onClick: (rowData) => {
          onScheduleCall(rowData);
        },
      }
    );
  }

  if (userPlanFeatures?.WEB_CALLS) {
    actionMenus.push(
      {
        title: "Instant Email",
        type: "INSTANT_EMAIL",
        onClick: (rowData) => {
          onEmailInstant(rowData);
        },
      },
      {
        title: "Schedule Email",
        type: "SCHEDULE_EMAIL",
        onClick: (rowData) => {
          onScheduleEmail(rowData);
        },
      }
    );
  }

  const onEdit = (rowData) => {
    navigate(
      (selectedTab == 1 ? "/edit-contact/" : "/edit-group/") + rowData?.id
    );
  };
  const onDelete = (rowData) => {
    setselectedRow(rowData);
    setCOnfirmModel(true);
  };

  const onClickRowData = (rowData) => {
    const { type } = rowData;
    if (type == "INSTANT_CALL") {
      onCallInstant(rowData, true);
    } else if (type == "SCHEDULE_CALL") {
      showSchedulePopup(true);
    } else if (type == "INSTANT_EMAIL") {
      onEmailInstant(rowData, true);
    } else if (type == "SCHEDULE_EMAIL") {
      showScheduleEmailPopup(true);
    }
  };

  const downloadTemplateForGroup = async () => {
    setIsLoading(true);
    const result = await dispatch(downloadContactGroupTemplate());
    if (
      downloadContactGroupTemplate.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      await downloadFileAsBlob(result?.payload?.data?.url);
      setSuccessMessage("Template downloaded successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onDeleteContact = async () => {
    setIsLoading(true);
    setCOnfirmModel(false);
    const result = await dispatch(DeleteContact(selectedRow.id));
    if (
      DeleteContact.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Contact Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getContactsList(1);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onDeleteContactGroup = async () => {
    setIsLoading(true);
    setCOnfirmModel(false);
    const result = await dispatch(deleteContactGroup(selectedRow.id));
    if (
      deleteContactGroup.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Contact Group Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getContactsList(1);
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };
  const onDeleteConfirm = async () => {
    if (selectedTab == 1) {
      onDeleteContact();
    } else {
      onDeleteContactGroup();
    }
  };
  const onCallInstant = (rowData, isMultiple) => {
    setShowInstantCallPopup({
      visible: true,
      data: rowData,
      isMultiple: isMultiple ?? false,
    });
    // navigate("/call/" + rowData.id);
  };
  const onEmailInstant = (rowData, isMultiple) => {
    setShowInstantEmailPopup({
      visible: true,
      data: rowData,
      isMultiple: isMultiple ?? false,
    });
  };
  const onScheduleCall = (rowData) => {
    navigate((selectedTab == 1 ? "/call/" : "/group-call/") + rowData.id);
  };

  const onScheduleEmail = (rowData) => {
    navigate((selectedTab == 1 ? "/email/" : "/group-email/") + rowData.id);
  };

  const onClickUploadGroupUsers = () => {
    setShowUploadGroupUsers(true);
  };

  const onCloseUploadGroupUsers = () => {
    setShowUploadGroupUsers(false);
  };

  const handleOpenFilter = () => {
    setFilterData((p) => ({ ...p, isVisible: true }));
  };

  const handleCloseFilter = () => {
    setFilterData((p) => ({ ...p, isVisible: false }));
  };

  const onPressApplyFilter = (filter = INITIAL_CONTACT_FILTER_STATE) => {
    setFilterData({ isVisible: false, data: filter });
    getContactsList(1, localItemsPerPage, filter);
  };

  const filterCount = useMemo(() => {
    let count = 0;
    if (filterData?.data.isActive != null) {
      count++;
    }
    return count;
  }, [filterData, filterData?.data]);

  const onRowSelect = (rowData) => {
    const currentList = selectedTab == 1 ? contactList : contactGroupList;
    const setCurrentList =
      selectedTab == 1 ? setContactsList : setContactGroupList;
    if (rowData === "all") {
      const list = currentList.map((contact) => ({
        ...contact,
        checkedRow: allChecked ? false : true,
      }));
      return setCurrentList(list);
    } else if (rowData === "clear_all") {
      const list = currentList.map((contact) => ({
        ...contact,
        checkedRow: false,
      }));
      return setCurrentList(list);
    } else {
      const list = currentList.map((contact) => {
        if (contact.id === rowData.id) {
          return {
            ...contact,
            checkedRow: !contact.checkedRow,
          };
        } else {
          return {
            ...contact,
          };
        }
      });
      return setCurrentList(list);
    }
  };

  const currentSelectedRowsCount = useMemo(() => {
    const currentList = selectedTab == 1 ? contactList : contactGroupList;
    const list = currentList.filter((contact) => contact?.checkedRow);
    return list?.length;
  }, [selectedTab, contactList, contactGroupList]);

  const isRowChecked = () => {
    const currentList = selectedTab == 1 ? contactList : contactGroupList;
    const found = currentList.find((x) => x.checkedRow === true);
    if (found) {
      return true;
    } else {
      return false;
    }
  };

  const getSelectedList = () => {
    const currentList = selectedTab == 1 ? contactList : contactGroupList;
    const found = currentList
      .filter((x) => x.checkedRow === true)
      .map((x) => x.id);

    return found;
  };

  useEffect(() => {
    setSelectedTab(location.hash == "#groups" ? 2 : 1);
  }, [location.hash]);

  return (
    <>
      <div className="page__body">
        {errorModel ? <ErrorModel message={errorMessage} /> : ""}
        {successModel ? <SuccessModel message={successMessage} /> : ""}
        {isLoading ? <Loader /> : ""}
        {confirmModel ? (
          <ConfirmModel
            onAccept={onDeleteConfirm}
            onReject={() => {
              setCOnfirmModel(false);
            }}
            title={
              selectedTab == 1 ? "Delete Contact!" : "Delete Contact Group!"
            }
            message={`Are you sure you want to Delete the ${
              selectedTab == 1 ? "contact" : "contact group"
            }?`}
          />
        ) : (
          ""
        )}
        {showInstantCallPopup.visible ? (
          <CallInstantModal
            closePopup={closeInstantCallPopup}
            isForContactGroup={selectedTab != 1}
            currentContact={showInstantCallPopup.data}
            isMultiple={showInstantCallPopup?.isMultiple}
            contactsList={getSelectedList}
          />
        ) : null}
        {showInstantEmailPopup.visible ? (
          <InstantEmailModal
            closePopup={closeInstantEmailPopup}
            isForContactGroup={selectedTab != 1}
            currentContact={showInstantEmailPopup.data}
            isMultiple={showInstantEmailPopup?.isMultiple}
            contactsList={getSelectedList}
          />
        ) : null}
        {schedulePopup ? (
          <ScheduleCallPopup
            closePopup={closePopup}
            isForContactGroup={selectedTab != 1}
            contactsList={getSelectedList}
          />
        ) : (
          ""
        )}
        {scheduleEmailPopup ? (
          <ScheduleEmailPopup
            closePopup={closeScheduleEmailPopup}
            isForContactGroup={selectedTab != 1}
            contactsList={getSelectedList}
          />
        ) : (
          ""
        )}
        <div className="tabsWrap">
          <ul className="tabs">
            <li
              className={
                selectedTab === 1
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(1);
                navigate("#individual");
              }}
            >
              Individual
            </li>
            <li
              className={
                selectedTab === 2
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(2);
                navigate("#groups");
              }}
            >
              Groups
            </li>
          </ul>
        </div>
        <div className="tabsContent">
          <div className="tabsContent__content tabsContent__content--selected">
            <div className="tableWrap">
              <div className="tableWrap__head tableWrap__head--wrap">
                <div className="formRow m_0 w_100 formRow--flexEnd">
                  <div
                    className={`formCol ${
                      selectedTab == "1"
                        ? "formCol--flexInput"
                        : "formCol--flex"
                    }`}
                  >
                    <div className="formCol flexField">
                      <input
                        className="form__input form__input--search"
                        type="text"
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value.trimStart());
                        }}
                        spellCheck="false"
                        placeholder={
                          selectedTab == 1
                            ? "Search a Contact"
                            : "Search a Contact Group"
                        }
                      />
                    </div>
                    {selectedTab != 1 ? (
                      <div
                        class={`filter ${
                          filterData.isVisible ? "filter--open" : ""
                        }`}
                      >
                        {filterCount > 0 ? (
                          <button
                            className="btn btn__primary"
                            onClick={handleOpenFilter}
                          >
                            <FilterIcon color={"#fff"} />
                            Filter Applied ({filterCount})
                          </button>
                        ) : (
                          <button
                            className="btn btn__white"
                            onClick={handleOpenFilter}
                          >
                            <FilterIcon />
                            Filter
                          </button>
                        )}
                        {filterData.isVisible ? (
                          <ContactGroupFilterModal
                            closeFilter={handleCloseFilter}
                            filterData={filterData.data}
                            onPressApply={onPressApplyFilter}
                          />
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="btn__group">
                  {/* {isRowChecked() ? (
                    <button
                      className="btn btn__primary btn__outlined"
                      onClick={() => showSchedulePopup(true)}
                    >
                      Schedule a Call
                    </button>
                  ) : (
                    ""
                  )} */}
                  {selectedTab != 1 && userPlanFeatures?.IMPORT_CONTACTS_WITH_FORM_BUILDER && (
                    <>
                      <button
                        className="btn btn__primary btn__outlined"
                        onClick={downloadTemplateForGroup}
                      >
                        <ImportIcon />
                        Download Template
                      </button>
                      
                        <button
                          className="btn btn__primary btn__outlined"
                          onClick={() =>
                            selectedTab == 1 ? null : onClickUploadGroupUsers()
                          }
                        >
                          <ImportButtonIcon />
                          Import {selectedTab == 1 ? "Contacts" : "Group"}
                        </button>
                    </>
                  )}
                  <button
                    className="btn btn__primary"
                    onClick={() =>
                      navigate(selectedTab == 1 ? "/add-contact" : "/add-group")
                    }
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.00008 1.1665V12.8332M1.16675 6.99984H12.8334"
                        stroke="white"
                        stroke-width="1.67"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    {selectedTab == 1 ? "Add Contact" : "Add Group"}
                  </button>
                  {isRowChecked() && actionMenus?.length ? (
                    <>
                      <button
                        type="button"
                        className="btn btn__primary btn__outlined btn__circle"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      >
                        <svg
                          width={6}
                          height={24}
                          viewBox="0 0 6 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx={3} cy={3} r={3} fill="#8b58f1" />
                          <circle cx={3} cy={12} r={3} fill="#8b58f1" />
                          <circle cx={3} cy={21} r={3} fill="#8b58f1" />
                        </svg>
                      </button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        {Array.isArray(actionMenus)
                          ? actionMenus?.map((item, index) => (
                              <MenuItem
                                key={`${item?.title}-${index}`}
                                sx={{
                                  padding: ".70rem 1rem",
                                  fontSize: ".75rem",
                                  fontWeight: "400",
                                  width: 160,
                                }}
                                onClick={() => {
                                  handleClose();
                                  if (typeof item?.onClick == "function") {
                                    onClickRowData(item);
                                  }
                                }}
                              >
                                {item?.title}
                              </MenuItem>
                            ))
                          : null}
                      </Menu>
                    </>
                  ) : null}
                </div>
              </div>
              {currentSelectedRowsCount > 0 ? (
                <div className="tableWrap__record">
                  <h3 className="title">
                    {selectedTab == 1 ? "Contacts" : "Groups"} (
                    {currentSelectedRowsCount} of{" "}
                    {
                      (Array.isArray(
                        selectedTab == 1
                          ? setPageList(contactList)
                          : contactGroupList
                      )
                        ? selectedTab == 1
                          ? setPageList(contactList)
                          : contactGroupList
                        : []
                      )?.length
                    }{" "}
                    Selected)
                  </h3>
                  <button
                    className="btn btn__white"
                    onClick={() => {
                      onRowSelect("clear_all");
                    }}
                  >
                    Clear Selection
                  </button>
                </div>
              ) : null}
              <Table
                data={
                  selectedTab == 1 ? setPageList(contactList) : contactGroupList
                }
                columns={columns}
                hasAction="true"
                onEdit={onEdit}
                onDelete={onDelete}
                allChecked={allChecked}
                hasCheckBox={onRowSelect}
                isShowActionMenu
                showKebabKey={selectedTab == 2 ? "isActive" : false}
                actionMenus={actionMenus}
                onClickLink={(rowData) =>
                  selectedTab == 1
                    ? navigate(`/chat`, {
                        state: {
                          contactId: rowData?.id,
                        },
                      })
                    : navigate(`/group-members/${rowData?.id}`, {
                        state: {
                          name: rowData?.name,
                        },
                      })
                }
                noDataMsg={
                  (searchQuery && searchQuery?.length) || filterCount > 0
                    ? `No ${
                        selectedTab == "1" ? "Contact" : "Contact Group"
                      } Found!`
                    : `No ${selectedTab == "1" ? "Contact" : "Contact Group"}!`
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Pagination
        apiMethod={getContactsList}
        itemsPerPage={localItemsPerPage}
        setItemsPerPage={setLocalItemsPerPage}
      />
      {showLowCreditModal ? (
        <LowCreditModal onClose={() => setShowLowCreditModal(false)} />
      ) : null}
      {showUploadGroupUsers ? (
        <UploadContactUsersForGroupModal
          onClose={onCloseUploadGroupUsers}
          onSuccess={() => {
            onCloseUploadGroupUsers();
            getContactsList();
          }}
        />
      ) : null}
    </>
  );
};
